// Runtime + build-time API base resolution.
// Build-time: import.meta.env.VITE_API_BASE
// Runtime override: /config.json { "apiBase": "..." } — fetched at boot in main.jsx
let runtimeConfig = null;

export function setRuntimeConfig(cfg) {
  runtimeConfig = cfg || null;
}

export function apiBase() {
  if (runtimeConfig?.apiBase) return runtimeConfig.apiBase;
  return import.meta.env.VITE_API_BASE || '';
}
